import { Box, Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { useLocalStorage } from 'usehooks-ts'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { MultiFiltersSelector } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/CommandsFilterBar/MultifiltersSelector'
import { ViewOptionsSectionButton } from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/ShiftActionsBar/ViewOptionsSectionButton'
import { Separator } from 'modules/shift_management/components/ShiftManagement/Separator'

interface Props {
  canManageShifts: boolean
  hasNoneShiftManagementPlanning: boolean
}

const CommandsFilterBar = ({ canManageShifts, hasNoneShiftManagementPlanning }: Props) => {
  const [hasSeenNewEntryFlowHints] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.shiftManagementHasSeenNewEntryFlowHints,
    false
  )

  return (
    <Box flexDirection="row" gap="s32" alignItems="center" minWidth="none">
      <Box flexDirection="row" gap="s8" alignItems="center">
        <MultiFiltersSelector />
        <Separator />
        <Box minWidth="s96">
          {!hasSeenNewEntryFlowHints ? (
            <Hint.Popover
              step={1}
              title={i18n.t('shift_management.hints.filters.title')}
              description={i18n.t('shift_management.hints.filters.description')}
              actionLabel={i18n.t('common.next')}
              position="bottom right"
            >
              <ViewOptionsSectionButton
                disabled={hasNoneShiftManagementPlanning}
                canManageShifts={canManageShifts}
              />
            </Hint.Popover>
          ) : (
            <ViewOptionsSectionButton
              disabled={hasNoneShiftManagementPlanning}
              canManageShifts={canManageShifts}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(CommandsFilterBar)
